import { render, staticRenderFns } from "./AbadonedCartList.vue?vue&type=template&id=12d29199&scoped=true"
import script from "./AbadonedCartList.vue?vue&type=script&lang=js"
export * from "./AbadonedCartList.vue?vue&type=script&lang=js"
import style0 from "./AbadonedCartList.vue?vue&type=style&index=0&id=12d29199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d29199",
  null
  
)

export default component.exports